export const SUB_TYPES = [
  { value: "petroleum_spill", label: "Petroleum Spill" },
  { value: "chemical_spill", label: "Chemical Spill" },
  { value: "stormwater_discharge", label: "Stormwater Discharge" },
  { value: "air_emission", label: "Air Emission" },
  { value: "waste_mishandling", label: "Waste Mishandling" },
  { value: "asbestos", label: "Asbestos" },
  { value: "heat_stress", label: "Heat Stress" },
  { value: "noise_exceedance", label: "Noise Exceedance" },
  { value: "voc_release", label: "VOC Release" },
  { value: "other", label: "Other" },
];

export const subTypeLabel = (v, t) =>
  t ? t(`subtype.${v}`) : (SUB_TYPES.find((s) => s.value === v)?.label || v);

export const STATUS_ORDER = ["open", "reported", "contained", "resolved", "closed"];

export const STATUS_META = {
  open: { label: "Open", color: "#B84A22", bg: "#B84A22" },
  reported: { label: "Reported", color: "#D98014", bg: "#D98014" },
  contained: { label: "Contained", color: "#2E7599", bg: "#2E7599" },
  resolved: { label: "Resolved", color: "#6D9C55", bg: "#6D9C55" },
  closed: { label: "Closed", color: "#4B5950", bg: "#4B5950" },
};

export const SEVERITY = ["low", "medium", "high", "critical"];

export const ITEM_CATEGORIES = [
  { value: "air", label: "Air Quality" },
  { value: "water", label: "Water / Stormwater" },
  { value: "waste", label: "Waste / RCRA" },
  { value: "spill", label: "Spill / SPCC" },
  { value: "permit", label: "Permit Renewal" },
  { value: "reporting", label: "Reporting / Filing" },
  { value: "training", label: "Training" },
  { value: "general", label: "General" },
];

export const itemCategoryLabel = (v, t) =>
  t ? t(`category.${v}`) : (ITEM_CATEGORIES.find((c) => c.value === v)?.label || v);
